"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _store = require("@/api/store");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'InventoryAdjust',
  props: {
    bizType: {
      default: null,
      type: Number
    },
    listUrl: {
      default: null,
      type: String
    },
    productId: {
      type: Number,
      default: null
    },
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      specColumns: [],
      tabIndex: this.$route.params.tabIndex,
      fullscreenLoading: false,
      adjustRemark: '',
      formValidate: {
        id: 0,
        productName: '',
        specMode: false,
        image: ''
      },
      stockData: [],
      specCombinations: [],
      multipleSelection: [],
      batchDialog: {
        visible: false,
        title: '',
        operationType: 'add',
        adjustValue: 0,
        selectedItems: [],
        hasNegative: false
      }
    };
  },
  computed: {
    hasNegativeStock: function hasNegativeStock() {
      var _this = this;
      return this.stockData.some(function (item) {
        return _this.getFinalStock(item) < 0;
      });
    },
    batchHasNegative: function batchHasNegative() {
      var _this2 = this;
      return this.batchDialog.selectedItems.some(function (item) {
        return _this2.calculateFinalStock(item) < 0;
      });
    },
    hasAnyAdjustment: function hasAnyAdjustment() {
      return this.stockData.some(function (item) {
        return item.adjustValue > 0;
      });
    }
  },
  created: function created() {
    this.loadProductData();
  },
  watch: {
    productId: function productId(val, oldVal) {
      if (this.embedded && val && val !== oldVal) {
        this.resetAdjustState();
        this.loadProductData();
      }
    }
  },
  methods: {
    closeOpenPageAndGo: function closeOpenPageAndGo(obj) {
      this.$store.dispatch("tagsView/delView", this.$route);
      if (obj !== undefined) {
        this.$router.push(obj);
      }
    },
    goBack: function goBack() {
      var listPath = this.listUrl || this.$route.meta && this.$route.meta.activeMenu;
      if (!listPath) {
        this.$router.go(-1);
        return;
      }
      this.$store.dispatch('tagsView/delView', this.$route);
      var query = this.tabIndex ? {
        type: this.tabIndex
      } : {};
      this.$router.push({
        path: listPath,
        query: query
      });
    },
    getFinalStock: function getFinalStock(row) {
      return row.operationType === 'add' ? row.stock + row.adjustValue : row.stock - row.adjustValue;
    },
    getMaxAdjustValue: function getMaxAdjustValue(row) {
      return row.operationType === 'sub' ? row.stock : Infinity;
    },
    handleOperationChange: function handleOperationChange(row) {
      if (row.operationType === 'sub' && row.adjustValue > row.stock) {
        row.adjustValue = row.stock;
      }
    },
    handleAdjustValueChange: function handleAdjustValueChange(row) {
      if (row.operationType === 'sub' && row.adjustValue > row.stock) {
        row.adjustValue = row.stock;
      }
    },
    loadProductData: function loadProductData() {
      var _this3 = this;
      var id = this.productId || this.$route.params.id;
      if (!id) {
        return;
      }
      this.fullscreenLoading = true;
      (0, _store.productDetailApi)(id).then(function (res) {
        var productData = res.data || res;
        var specList = productData.specList || [];
        var skuList = productData.skuList || [];
        _this3.formValidate = {
          id: productData.id,
          productName: productData.productName,
          specMode: !!productData.specMode,
          image: productData.image
        };

        // 处理规格组合
        if (productData.specMode && specList.length > 0) {
          _this3.specCombinations = specList.map(function (spec) {
            return {
              specName: spec.specName,
              specValues: (spec.specValues || '').split(',').filter(Boolean)
            };
          });

          // 提取规格列信息
          _this3.specColumns = specList.map(function (spec) {
            return {
              label: spec.specName,
              prop: spec.specName
            };
          });
          var attrsForFormat = specList.map(function (item) {
            return {
              attrName: item.specName,
              attrValue: (item.specValues || '').split(',').filter(Boolean)
            };
          });
          var formattedAttrs = _this3.attrFormat(attrsForFormat);
          var skuMap = {};
          skuList.forEach(function (item) {
            var raw = item.specMap;
            if (!raw) return;
            var parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
            var key = Object.values(parsed).sort().join('/');
            skuMap[key] = item;
          });
          _this3.stockData = formattedAttrs.map(function (item) {
            var key = Object.values(item.attrValue).sort().join('/');
            var originalItem = skuMap[key] || {};

            // 将规格属性展开到行数据中
            var rowData = _objectSpread(_objectSpread({}, originalItem), {}, {
              operationType: 'add',
              adjustValue: 0,
              originalStock: originalItem.stock || 0,
              originalVersion: originalItem.version || 0
            });

            // 添加规格属性到行数据
            for (var _i = 0, _Object$entries = Object.entries(item.attrValue); _i < _Object$entries.length; _i++) {
              var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
                _key = _Object$entries$_i[0],
                value = _Object$entries$_i[1];
              rowData[_key] = value;
            }
            return rowData;
          });
        } else {
          // 单规格处理
          _this3.specCombinations = [];
          _this3.specColumns = [];
          _this3.stockData = skuList.map(function (item) {
            return _objectSpread(_objectSpread({}, item), {}, {
              operationType: 'add',
              adjustValue: 0,
              originalStock: item.stock,
              originalVersion: item.version || 0
            });
          });
        }
      }).catch(function (err) {
        _this3.$message.error('加载商品数据失败: ' + (err.message || err));
      }).finally(function () {
        _this3.fullscreenLoading = false;
      });
    },
    attrFormat: function attrFormat(arr) {
      var data = [];
      var res = [];
      return format(arr);
      function format(arr) {
        if (arr.length > 1) {
          arr.forEach(function (v, i) {
            if (i === 0) data = arr[i]['attrValue'];
            var tmp = [];
            if (!data) return;
            data.forEach(function (vv) {
              arr[i + 1] && arr[i + 1]['attrValue'] && arr[i + 1]['attrValue'].forEach(function (g) {
                var rep2 = (i !== 0 ? '' : arr[i]['attrName'] + '_') + vv + '$&' + arr[i + 1]['attrName'] + '_' + g;
                tmp.push(rep2);
                if (i === arr.length - 2) {
                  var rep4 = {
                    image: '',
                    price: 0,
                    cost: 0,
                    otPrice: 0,
                    stock: 0,
                    barCode: '',
                    weight: 0,
                    volume: 0,
                    brokerage: 0,
                    brokerage_two: 0
                  };
                  rep2.split('$&').forEach(function (h, k) {
                    var rep3 = h.split('_');
                    if (!rep4['attrValue']) rep4['attrValue'] = {};
                    rep4['attrValue'][rep3[0]] = rep3.length > 1 ? rep3[1] : '';
                  });
                  for (var attrValueKey in rep4.attrValue) {
                    rep4[attrValueKey] = rep4.attrValue[attrValueKey];
                  }
                  res.push(rep4);
                }
              });
            });
            data = tmp.length ? tmp : [];
          });
        } else {
          var dataArr = [];
          arr.forEach(function (v, k) {
            v['attrValue'].forEach(function (vv, kk) {
              dataArr[kk] = v['attrName'] + '_' + vv;
              res[kk] = {
                image: '',
                price: 0,
                cost: 0,
                otPrice: 0,
                stock: 0,
                barCode: '',
                weight: 0,
                volume: 0,
                brokerage: 0,
                brokerage_two: 0,
                attrValue: _defineProperty({}, v['attrName'], vv)
              };
              // Object.values(res[kk].attrValue).forEach((v, i) => {
              //   res[kk]['value' + i] = v
              // })
              for (var attrValueKey in res[kk].attrValue) {
                res[kk][attrValueKey] = res[kk].attrValue[attrValueKey];
              }
            });
          });
          data.push(dataArr.join('$&'));
        }
        return res;
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    batchAdjust: function batchAdjust(type) {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请至少选择一条数据进行操作');
        return;
      }
      this.batchDialog = {
        visible: true,
        title: type === 'add' ? '批量增加库存' : '批量减少库存',
        operationType: type,
        adjustValue: 0,
        // 初始值改为0
        selectedItems: _toConsumableArray(this.multipleSelection)
      };
    },
    calculateFinalStock: function calculateFinalStock(row) {
      return this.batchDialog.operationType === 'add' ? row.stock + this.batchDialog.adjustValue : row.stock - this.batchDialog.adjustValue;
    },
    handleBatchValueChange: function handleBatchValueChange() {
      var _this4 = this;
      // 实时检查是否有负库存情况
      this.batchDialog.hasNegative = this.batchDialog.selectedItems.some(function (item) {
        return _this4.calculateFinalStock(item) < 0;
      });
    },
    confirmBatchAdjust: function confirmBatchAdjust() {
      var _this5 = this;
      if (this.batchHasNegative) {
        this.$message.error('存在调整后库存为负数的情况，请修改调整数量');
        return;
      }
      if (this.batchDialog.adjustValue === 0) {
        this.$message.warning('调整数量为0，没有执行任何调整');
        this.batchDialog.visible = false;
        return;
      }

      // 更新选中行的操作类型和调整值
      this.multipleSelection.forEach(function (selected) {
        var targetRow = _this5.stockData.find(function (row) {
          return row.id === selected.id;
        });
        if (targetRow) {
          targetRow.operationType = _this5.batchDialog.operationType;
          targetRow.adjustValue = _this5.batchDialog.adjustValue;
        }
      });

      // 同时更新表格中所有选中行的状态（解决element-ui表格数据更新不及时问题）
      this.$nextTick(function () {
        _this5.$refs.stockTable.clearSelection();
        _this5.multipleSelection.forEach(function (row) {
          var targetRow = _this5.stockData.find(function (item) {
            return item.id === row.id;
          });
          if (targetRow) {
            _this5.$refs.stockTable.toggleRowSelection(targetRow, true);
          }
        });
      });
      this.batchDialog.visible = false;
    },
    resetAdjustState: function resetAdjustState() {
      if (this.$refs.stockTable) {
        this.$refs.stockTable.clearSelection();
      }
      this.stockData = [];
      this.specCombinations = [];
      this.specColumns = [];
      this.multipleSelection = [];
      if (!this.embedded) {
        this.adjustRemark = '';
      }
    },
    resetAdjust: function resetAdjust() {
      if (this.$refs.stockTable) {
        this.$refs.stockTable.clearSelection();
      }
      this.stockData.forEach(function (item) {
        item.operationType = 'add';
        item.adjustValue = 0;
      });
      if (!this.embedded) {
        this.adjustRemark = '';
      }
    },
    validateForBatch: function validateForBatch() {
      if (this.hasNegativeStock) {
        return {
          valid: false,
          message: '存在调整后库存为负数的情况，请修改后再提交'
        };
      }
      if (!this.hasAnyAdjustment) {
        return {
          valid: false,
          skip: true
        };
      }
      return {
        valid: true
      };
    },
    getAdjustPayload: function getAdjustPayload(remark) {
      return {
        productId: this.formValidate.id,
        remark: remark,
        bizType: this.bizType,
        adjustments: this.stockData.filter(function (item) {
          return item.adjustValue > 0;
        }).map(function (item) {
          return {
            skuId: item.id,
            operation: item.operationType,
            value: item.adjustValue,
            originalStock: item.originalStock,
            version: item.originalVersion
          };
        })
      };
    },
    submitAdjust: function submitAdjust() {
      var _this6 = this;
      if (!this.adjustRemark) {
        return this.$message.warning('请填写调整备注');
      }
      if (this.hasNegativeStock) {
        return this.$message.warning('存在调整后库存为负数的情况，请修改后再提交');
      }
      if (!this.hasAnyAdjustment) {
        return this.$message.warning('请至少调整一个规格的库存数量');
      }
      var adjustData = this.getAdjustPayload(this.adjustRemark);
      this.fullscreenLoading = true;
      (0, _store.inventoryAdjustApi)(adjustData).then(function () {
        _this6.$message.success('库存调整成功');
        setTimeout(function () {
          _this6.fullscreenLoading = false;
          _this6.closeOpenPageAndGo({
            path: _this6.listUrl + "?type=" + _this6.tabIndex
          });
        }, 500);
        _this6.adjustRemark = '';
      }).catch(function (err) {
        var msg = String(err || '');
        if (msg.includes('版本')) {
          _this6.resetAdjust();
          _this6.loadProductData();
        }
      }).finally(function () {
        _this6.fullscreenLoading = false;
      });
    }
  }
};